import { defineComponent } from 'vue'
import './style.sass'
import BetaVersion from "@/components/beta-version";

export default defineComponent({
    name: 'NotFound',
    layout: "default",
    render() {
        return (
            <div class="not-found-page">
                <BetaVersion />
                <div class="error-container">
                    <div class="not-found-svg"></div>
                    <p class="not-found-text">
                        Страница не найдена.
                        <br />
                        По вашему запросу ничего нет.
                    </p>

                </div>
            </div>
        )
    }
})
